import produce from 'immer';
import {
  GET_SUBLINE_ITEM_DETAILS,
  GET_SUBLINE_ITEM_TRANSACTIONS,
  SET_SUBLINE_ITEM_TRANSACTIONS_LOADING,
  GET_SUBLINE_ITEM_PARTS,
  SET_SUBLINE_ITEM_PARTS_LOADING,
  SET_SUBLINE_ITEM_PARTS_ERROR,
  GET_SUBLINE_ITEM_EXPLODED_VIEW,
  SET_SUBLINE_ITEM_EXPLODED_VIEW_LOADING,
  SET_SUBLINE_ITEM_EXPLODED_VIEW_ERROR,
  RESET_SUBLINE_ITEM,
  UPDATE_SUBLINE_ITEM
} from '@actions/types';

export const initialState = {
  info: {},
  transactions: [],
  transactionsLoading: false,
  parts: [],
  partsLoading: false,
  partsError: null,
  explodedViewAttachments: [],
  explodedViewLoading: false,
  explodedViewLoaded: false,
  explodedViewError: null
};

export default produce((draft, action) => {
  switch (action.type) {
    case GET_SUBLINE_ITEM_DETAILS:
    case UPDATE_SUBLINE_ITEM:
      draft.info = action.payload;
      return draft;

    case GET_SUBLINE_ITEM_TRANSACTIONS:
      draft.transactions = action.payload;
      draft.transactionsLoading = false;
      return draft;

    case SET_SUBLINE_ITEM_TRANSACTIONS_LOADING:
      draft.transactionsLoading = action.payload;
      return draft;

    case GET_SUBLINE_ITEM_PARTS:
      draft.parts = action.payload;
      draft.partsLoading = false;
      return draft;

    case SET_SUBLINE_ITEM_PARTS_LOADING:
      draft.partsError = null;
      draft.partsLoading = action.payload;
      return draft;

    case SET_SUBLINE_ITEM_PARTS_ERROR:
      draft.partsError = action.payload;
      draft.partsLoading = false;
      return draft;

    case SET_SUBLINE_ITEM_EXPLODED_VIEW_LOADING:
      draft.explodedViewLoading = true;
      draft.explodedViewLoaded = false;
      draft.explodedViewError = null;
      return draft;

    case GET_SUBLINE_ITEM_EXPLODED_VIEW:
      draft.explodedViewAttachments = action.payload;
      draft.explodedViewLoading = false;
      draft.explodedViewLoaded = true;
      return draft;

    case SET_SUBLINE_ITEM_EXPLODED_VIEW_ERROR:
      draft.explodedViewError = action.payload;
      draft.explodedViewLoading = false;
      draft.explodedViewLoaded = true;
      return draft;

    case RESET_SUBLINE_ITEM:
      return { ...initialState };

    default:
      return draft;
  }
}, initialState);
